import React, { useState } from "react";
import Header from "../../components/Header";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { db } from "../../firebase";
import { Switch } from "@headlessui/react";
import { ToastContainer, toast } from "react-toastify";

function ProfileStatus() {
  const { currentUser } = useAuth();
  let userData = JSON.parse(sessionStorage.getItem("authUser"));
  let newP = JSON.parse(sessionStorage.getItem("public"));
  const [enabled, setEnabled] = useState(newP == null ? userData.public : newP);

  async function handleChange() {
    enabled ? setEnabled(false) : setEnabled(true);
    sessionStorage.removeItem("public");
    try {
      await db
        .collection("mentors")
        .doc(currentUser.uid)
        .update({
          public: enabled ? false : true,
        });
      sessionStorage.setItem("public", enabled ? false : true);
      toast.success(
        `${
          enabled ? "Now hidden" : "Now your profile is avialable for bookings"
        }`
      );
    } catch {
      toast.error("Unable to update right now!");
    }
  }
  return (
    <div>
      <Header />
      <div className="container mx-auto sm:py-24 sm:px-2 ">
        <div className="mt-10 sm:-mt-12">
          <div className="md:grid md:grid-cols-1 md:gap-6">
            <div className="md:col-span-1">
              <div className="px-4 sm:px-0">
                <h3 className="text-lg font-medium max-w-prose text-gray-500">
                  <Link to="/mentor/dashboard">Account</Link> &nbsp; &gt; &nbsp;
                  Profile Status
                </h3>
                <h3 className="text-3xl mt-4 font-bold leading-relaxed text-gray-900">
                  Profile Status
                </h3>
              </div>
            </div>

            <div className="mt-5 md:mt-0 md:col-span-2">
              <form>
                <div className="overflow-hidden sm:rounded-md">
                  <div>
                    <div className=" bg-white p-4 sm:p-0">
                      <div className="grid grid-cols-6 gap-6">
                        <div className="col-span-6 sm:col-span-3">
                          <div className="flex justify-between">
                            <div>
                              <label
                                htmlFor="first_name"
                                className="text-lg font-medium text-gray-900 border-none"
                              >
                                Available for Bookings
                              </label>
                              <p className="mt-2 text-sm text-gray-600 w-3/4">
                                You can change this toggle to show or hide your
                                profile from find mentors sections in case
                                you're not available to take sessions
                              </p>
                            </div>

                            <div>
                              <Switch
                                checked={enabled}
                                onChange={handleChange}
                                className={`${
                                  enabled ? "bg-blue-600" : "bg-gray-200"
                                } relative inline-flex items-center h-6 rounded-full w-11`}
                              >
                                <span
                                  className={`${
                                    enabled ? "translate-x-6" : "translate-x-1"
                                  } inline-block w-4 h-4 transform bg-white rounded-full`}
                                />
                              </Switch>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="px-4 py-8 text-left sm:px-0"></div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer hideProgressBar={true} position="bottom-right" />
    </div>
  );
}

export default ProfileStatus;
